import Headroom from 'headroom.js';
import dropdownEvent from '../base/_dropdownEvent.js';

export default class Masthead {
	constructor( node = '.masthead' ) {
		this.node = typeof node === 'string' ? document.querySelector( node ) : node;

		if ( ! this.node instanceof HTMLElement ) {
			return;
		}

		this.menu            = this.node.querySelector('.masthead__menu');
		this.items           = this.node.querySelector('.masthead__items');
		this.back            = this.node.querySelector('.masthead__back');
		this.searchToggler   = this.node.querySelector('.masthead__search-toggler');
		this.search          = this.node.querySelector('.masthead__search');
		this.searchInput     = this.search.querySelector('.masthead__search-input');
		this.searchForm      = this.search.querySelector('.masthead__search-form');
		this.searchCloser    = this.search.querySelector('.masthead__search-closer');
		this.searchOpenClass = 'masthead__search--opened';
		this.opened          = false;

		// headroom
		this.headroom = new Headroom(
			this.node,
			{
				tolerance: {
					up: 7,
					down: 5
				},
				classes: {
					initial  : 'masthead',
					pinned   : 'masthead--pinned',
					unpinned : 'masthead--unpinned',
					top      : 'masthead--top',
					notTop   : 'masthead--not-top',
					bottom   : 'masthead--bottom',
					notBottom: 'masthead--not-bottom',
					frozen   : 'masthead--frozen',
				}
			},
		);
		this.headroom.init();
		this.headroom.update(this.headroom);

		// dropdowns
		const intentActivate = (e) => {
			if ( this.isDesktop() ) {
				e.target.classList.add( 'masthead__item--active' );

				const mega = e.target.querySelector('.masthead__mega');

				if ( mega ) {
					mega.classList.add('masthead__mega--active');
				}
			}
		}

		const intentDeactivate = (e) => {
			if ( this.isDesktop() ) {
				e.target.classList.remove( 'masthead__item--active' );

				const mega = e.target.querySelector('.masthead__mega');

				if ( mega ) {
					mega.classList.remove('masthead__mega--active');
				}
			}
		}

		const mobileActivate = (e) => {
			if ( this.isDesktop() ) {
				return;
			}

			if ( ! e.target.matches( '.masthead__item--mega > .masthead__link' ) && ! e.target.closest( '.masthead__item--mega > .masthead__link' ) ) {
				return;
			}

			e.preventDefault();
			e.target.closest('.masthead__item--mega').querySelector('.masthead__mega').classList.add('masthead__mega--active');
			this.back.classList.add( 'masthead__back--active' );
			this.items.classList.add( 'masthead__items--active' );
		}

		this.node.querySelectorAll( '.masthead__item--mega' ).forEach( node => {
			dropdownEvent( node );

			node.addEventListener( 'click', mobileActivate );
			node.addEventListener( 'dropdown:activate', intentActivate );
			node.addEventListener( 'dropdown:deactivate', intentDeactivate );
		} );

		this.back.addEventListener( 'click', (e) => {
			if ( ! this.isDesktop() ) {
				e.preventDefault();
				this.back.classList.remove( 'masthead__back--active' );
				this.items.classList.remove( 'masthead__items--active' );
				this.node.querySelectorAll('.masthead__mega--active').forEach( n => n.classList.remove('masthead__mega--active') );
			}
		});

		// search
		this.searchToggler.addEventListener( 'click', (e) => {
			e.preventDefault();

			if ( this.node.classList.contains( 'masthead--search-open' ) ) {
				this.close();
				this.node.classList.remove( 'masthead--search-open' );
			} else {
				this.open();
				this.node.classList.toggle( 'masthead--search-open' );
			}
		} );

		// menu
		this.menu.addEventListener('click', (e) => {
			e.preventDefault();

			if ( this.node.classList.contains( 'masthead--search-open' ) ) {
				this.node.classList.remove( 'masthead--search-open' );
			} else {
				this.toggle();
			}
		});

		// animate the masthead in when it's immersive
		if ( this.node.classList.contains( 'masthead--immersive' ) ) {
			setTimeout( () => this.node.classList.add( 'masthead--immersive-in' ), 1750 );
		}
	}

	isDesktop() {
		return window.matchMedia( '(min-width:62em)' ).matches ? true : false;
	}

	open() {
		this.node.classList.add( 'masthead--menu-open' );
		document.body.classList.add( 'masthead-fixed' );
		this.opened = true;
	}

	close() {
		this.node.classList.remove( 'masthead--menu-open' );
		document.body.classList.remove( 'masthead-fixed' );
		this.opened = false;
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}
}
